<div class="pain-selector-card">
    <div class="input-title">三、症狀調查</div>
    <div class="input-subtitle">點選部位選擇疼痛程度，未點選視為無疼痛。</div>

    <!-- 人體圖片區 -->
    <div class="body-container">
        <img src="assets/img/human-anatody-white-background.png" alt="人體背面圖" class="body-img" />

        <!-- 點位 -->
        <ng-container *ngFor="let point of bodyPoints; let i = index">

            <!-- 點（可點擊） -->
            <div class="point-wrapper" [ngStyle]="getPointStyle(point)" (click)="selectPoint(i)">
                <div class="hit-area"></div>

                <div class="point-dot" [class.active]="selectedIndex === i" [class.has-pain]="painMap[point.key] > 0">
                </div>
            </div>

            <!-- 標籤 -->
            <div class="point-label" [ngStyle]="getLabelStyle(point)">
                {{ point.label }}
            </div>

        </ng-container>
    </div>

    <!-- 當前部位 -->
    <div class="current-part">
        現在部位：<span>{{ currentPoint?.label || '未選擇' }}</span>
    </div>

    <!-- 切換 -->
    <div class="nav-actions">
        <button class="circle-btn" (click)="prevPoint()">‹</button>
        <button class="circle-btn" (click)="nextPoint()">›</button>
    </div>

    <!-- 疼痛 slider -->
    <div class="pain-level-block" *ngIf="currentPoint">
        <div class="pain-value">
            疼痛程度：{{ painMap[currentPoint.key] ?? 0 }}
        </div>

        <input #painSlider type="range" min="0" max="5" step="1" class="pain-slider" [ngModel]="painMap[currentPoint.key] ?? 0"
            (ngModelChange)="updatePainLevel($event)" />

        <div class="slider-labels">
            <span>0<br />不痛</span>
            <span>1</span>
            <span>2</span>
            <span>3</span>
            <span>4</span>
            <span>5<br />劇痛</span>
        </div>
    </div>

    <!-- 結果 -->
<div class="result-block" *ngIf="hasPainData">
  <div class="result-title">已選擇部位</div>

  <ng-container *ngFor="let item of filteredDisplayList">
    <div class="result-item" *ngIf="item.pain > 0">
      <span>{{ item.label }}</span>
      <span>疼痛：{{ item.pain }}</span>
    </div>
  </ng-container>
</div>
</div>